const mrpReabHeader = [
  {
    group: 'SAP',
    columns: [
      {
        name: 'Código Material',
        id: 'sap-codigo',
        show: true
      },
      {
        name: 'Código Loja',
        id: 'sap-loja',
        show: true
      },
      {
        name: 'Código Fornecedor',
        id: 'sap-fornecedor',
        show: true
      },
      {
        name: 'Quantidade Desejada',
        id: 'sap-desejada',
        show: true
      },
      {
        name: 'Tipo Pedido',
        id: 'sap-tipo-pedido',
        show: true
      },
      {
        name: 'Tipo Data',
        id: 'sap-tipo-data',
        show: true
      },
      {
        name: 'Data Remessa',
        id: 'sap-data-remessa',
        show: true
      },
      {
        name: 'Desconto',
        id: 'sap-desconto',
        show: true
      },
      {
        name: 'Forma de pagamento',
        id: 'sap-forma-pagamento',
        show: true
      }
    ]
  }
]

export default mrpReabHeader
